export default "__VITE_ASSET__ClYibzNQ__"